import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Box, CircularProgress, Stack } from "@mui/material";
import TableData from "./components/TableData";
import MDButton from "components/MDButton";
import { fetchAirportTimeTable } from "../../data/fetchAirportTimeTable";

function TableAirportInfoHub() {
  const { t } = useTranslation();
  const [selectedType, setSelectedType] = useState("arrival");
  const [resetTrigger, setResetTrigger] = useState(0);
  const [loading, setLoading] = useState(false);
  const [rows, setRows] = useState([]);
  const [cache, setCache] = useState({ arrival: null, departure: null });

  useEffect(() => {
    const loadData = async () => {
      setLoading(true);

      const endpoint =
        selectedType === "arrival"
          ? "/rpc/get_next_hour_flights_at"
          : "/rpc/get_next_hour_flights_dt";

      // If cached, reuse
      if (cache[selectedType]) {
        setRows(cache[selectedType]);
        setLoading(false);
        return;
      }

      try {
        const data = await fetchAirportTimeTable(endpoint, selectedType);
        setRows(data);

        setCache((prev) => ({
          ...prev,
          [selectedType]: data,
        }));
      } catch (error) {
        setRows([]);
      } finally {
        setLoading(false);
      }
    };

    loadData();
  }, [selectedType]);

  const handleTypeChange = (type) => {
    if (type !== selectedType) {
      setSelectedType(type);
      setResetTrigger((r) => r + 1);
    }
  };

  const columns = [
    { key: "flight_code", label: t("trafficMonitoring.infohub.airportTable.flightCode") },
    { key: "airline", label: t("trafficMonitoring.infohub.airportTable.airline") },
    { key: "time", label: selectedType === "arrival" ? t("trafficMonitoring.infohub.airportTable.arrivalTime") : t("trafficMonitoring.infohub.airportTable.departureTime") },
  ];

  return (
    <Box sx={{ position: "relative" }}>
      {loading && (
        <Box
          sx={{
            position: "absolute",
            zIndex: 10,
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            bgcolor: "rgba(0, 0, 0, 0.4)",
            backdropFilter: "blur(3px)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            borderRadius: 2,
          }}
        >
          <CircularProgress sx={{ color: "#fff" }} />
        </Box>
      )}

      <Stack direction="row" spacing={2} sx={{ mb: 2 }}>
        <MDButton
          variant={selectedType === "arrival" ? "contained" : "outlined"}
          onClick={() => handleTypeChange("arrival")}
        >
          {t("trafficMonitoring.infohub.arrival")}
        </MDButton>
        <MDButton
          variant={selectedType === "departure" ? "contained" : "outlined"}
          onClick={() => handleTypeChange("departure")}
        >
          {t("trafficMonitoring.infohub.departure")}
        </MDButton>
      </Stack>

      <TableData rows={rows} resetPageTrigger={resetTrigger} columns={columns} />
    </Box>
  );
}

export default TableAirportInfoHub;
